import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContact = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 79,
	height: 79,
	viewBox: "0 0 79 79",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 39.4631,
			cy: 39.3594,
			r: 38,
			stroke: "#63688B",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0901 47.6631C21.6788 47.3721 11.6536 56.4638 11.0957 63.8598C14.3193 69.6622 28.3738 76.7621 40.0901 77.4896C49.4632 78.0716 63.3177 69.4873 67.1859 65.1492C66.7675 57.9957 58.5015 47.9541 40.0901 47.6631Z",
			fill: "#63688B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0957 63.8572C12.0779 57.1985 22.6705 47.6562 39.9571 47.6562C57.2438 47.6562 66.5311 57.1985 67.1859 63.8572",
			stroke: "#63688B",
			strokeWidth: 2.57886,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39.4631,
			cy: 39.3594,
			r: 38,
			stroke: "#C9D8FC",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 39.4618,
			cy: 29.3192,
			r: 12.9286,
			fill: "#63688B",
			stroke: "#63688B",
			strokeWidth: 2
		})
	]
});
export default SvgContact;
